import { Box, IconButton, Card } from '@mui/material';
import React, { useState } from 'react';
import DeleteIcon from '@mui/icons-material/Delete';

import { ApiKeyResponse } from '../../../store/modules/merchant/types';
import ApiKeyDeleteModal from '../ApiKeyDeleteModal';
import { useMerchant } from '../../../contexts/MerchantContext';
import { ApiKeyInfo } from '../components/ApiKeyInfo';

interface Props {
  apiKey: ApiKeyResponse;
}

const displayKey = 'SKIP_******';

const ApiKeyCard = ({ apiKey }: Props) => {
  const { canUpdateMerchantSettings } = useMerchant();
  const hasModifyAccess = canUpdateMerchantSettings();
  const [isDeleteApiKeyModalOpen, setDeleteApiKeyModalOpen] = useState(false);

  const handleOpenModal = () => setDeleteApiKeyModalOpen(true);
  const handleCloseModal = () => setDeleteApiKeyModalOpen(false);

  return (
    <Box>
      <Card
        sx={{
          boxShadow: (theme) => theme.elevation[2],
          borderRadius: '8px',
          border: '1px solid #F3F3F3',
          p: 2,
          mb: 2,
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
        }}
      >
        <ApiKeyInfo apiKey={apiKey} displayKey={displayKey} />
        {hasModifyAccess && (
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
            <IconButton color="error" aria-label="delete" onClick={handleOpenModal}>
              <DeleteIcon sx={{ color: '#1E1E1E', fontSize: '24px' }} />
            </IconButton>
            <ApiKeyDeleteModal
              apiKey={apiKey}
              displayKey={displayKey}
              open={isDeleteApiKeyModalOpen}
              onClose={handleCloseModal}
            />
          </Box>
        )}
      </Card>
    </Box>
  );
};
export default ApiKeyCard;
